"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.input = React.createRef();
        _this.focusInput = function () { return _this.input.current && _this.input.current.focus(); };
        _this.clearInput = function () { return _this.props.onChange(''); };
        _this.onInputChange = function (e) {
            return _this.props.onChange(e.target.value);
        };
        return _this;
    }
    SearchInput.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, style = _b.style, value = _b.value, disabled = _b.disabled;
        return (React.createElement("div", { className: classnames_1.default(styles.searchInput, className), style: style, onClick: this.focusInput },
            React.createElement("input", { ref: this.input, type: "search", value: value, onChange: this.onInputChange, disabled: disabled }),
            React.createElement("button", { className: classnames_1.default(styles.closeButton, (_a = {}, _a[styles.on] = !!value, _a)), onClick: this.clearInput, disabled: disabled },
                React.createElement(icons_1.ClearInputIcon, null)),
            React.createElement(icons_1.SearchIcon, { className: styles.searchIcon })));
    };
    return SearchInput;
}(React.Component));
exports.default = SearchInput;
